import RemoveTrailingSlash from './Text/RemoveTrailingSlash';

const BaseUrl = (removeTrailingSlash = false) => {
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    let response: string | undefined;

    if (!htmlElement) {
        throw new Error('There is no html defined');
    }

    if (!bodyElement) {
        throw new Error('There is no body defined');
    }

    if (htmlElement.dataset.baseUrl !== undefined) {
        response = htmlElement.dataset.baseUrl;
    } else if (bodyElement.dataset.baseUrl !== undefined) {
        response = bodyElement.dataset.baseUrl;
    } else {
        throw new Error('The html and body have no base-url data attribute.');
    }

    if (removeTrailingSlash) {
        response = RemoveTrailingSlash(response);
    }

    return response;
};

export default BaseUrl;
